// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mob-popup {
  position: fixed;
  top: 76px;
  width: 100%;
  left: 0;
  z-index: 11;
  color: var(--white);
  background: rgba(15, 25, 35, 0.8);
  border-radius: 0.875rem;
  backdrop-filter: blur(18px);
}
.mob-popup svg {
  width: 0.75rem;
  height: 0.75rem;
}
.mob-popup .popup-title {
  font-size: 0.875rem;
  font-weight: 600;
}
.mob-popup .popup-subtitle {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--gray-40);
}
.mob-popup .icons-wrap svg {
  height: 2rem;
  width: 2rem;
}
.mob-popup .btn-primary {
  font-size: 0.75rem;
  min-height: 1.75rem;
}

.add-to-screen-modal.fade .modal-dialog {
  transition: all 2s ease-out;
  bottom: 0 !important;
  min-height: auto;
  transform: none;
}
.add-to-screen-modal.show .modal-dialog {
  transition: all 2s ease-out;
}
.add-to-screen-modal.show {
  transform: none;
  transition: all 1s ease-out;
}
.add-to-screen-modal.show .modal-dialog {
  transform: translate(0, 0) !important;
  transition: all 1s ease-out;
}
.add-to-screen-modal.show.fade {
  transition: all 1s ease-out !important;
}
.add-to-screen-modal .modal-dialog {
  transition: transform 1s ease-out;
  transform: translate(0, 300px) !important;
  bottom: 0 !important;
  left: 0% !important;
  right: 0% !important;
  position: fixed;
  min-height: auto;
  margin-bottom: 0 !important;
}
.add-to-screen-modal .modal-body svg {
  width: 4.5rem;
  height: 4.5rem;
}
.add-to-screen-modal .modal-body h3 {
  font-size: 1rem;
}
.add-to-screen-modal .modal-body p {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--gray-40);
  margin-bottom: 0;
}
.add-to-screen-modal .modal-body p svg {
  height: 0.875rem;
  width: 0.875rem;
}
.add-to-screen-modal .modal-body p span {
  color: var(--blue-300);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/PWA/pwa.scss"],"names":[],"mappings":"AAAA;EAEI,eAAA;EACA,SAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,cAAA;EACA,eAAA;AAAN;AAEI;EACE,mBAAA;EACA,gBAAA;AAAN;AAEI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAAN;AAGM;EACE,YAAA;EACA,WAAA;AADR;AAII;EACE,kBAAA;EACA,mBAAA;AAFN;;AAMI;EACI,2BAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAMI;EACI,2BAAA;AAJR;AAMI;EACI,eAAA;EACC,2BAAA;AAJT;AAKQ;EACI,qCAAA;EAEA,2BAAA;AAJZ;AAMQ;EACI,sCAAA;AAJZ;AAQI;EACG,iCAAA;EACC,yCAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AANR;AASM;EACE,aAAA;EACA,cAAA;AAPR;AASM;EACE,eAAA;AAPR;AASM;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AAPR;AAQQ;EACE,gBAAA;EACA,eAAA;AANV;AAQO;EACC,sBAAA;EACA,gBAAA;AANR","sourcesContent":[".mob-popup {\n\n    position: fixed;\n    top: 76px;\n    width: 100%;\n    left: 0;\n    z-index: 11;\n    color: var(--white);\n    background: #0f1923cc;\n    border-radius: 0.875rem;\n    backdrop-filter: blur(18px);\n\n    svg {\n      width: 0.75rem;\n      height: 0.75rem;\n    }\n    .popup-title {\n      font-size: .875rem;\n      font-weight: 600;\n    }\n    .popup-subtitle {\n      font-size: .75rem;\n      font-weight: 400;\n      color: var(--gray-40);\n    }\n    .icons-wrap {\n      svg {\n        height: 2rem;\n        width: 2rem;\n      }\n    }\n    .btn-primary {\n      font-size: 0.75rem;\n      min-height: 1.75rem;\n    }\n  }\n  .add-to-screen-modal {\n    &.fade .modal-dialog {\n        transition: all 2s ease-out;\n        bottom: 0 !important;\n        min-height: auto;\n        transform: none;\n\n    }\n    &.show .modal-dialog {\n        transition: all 2s ease-out;\n    }\n    &.show {\n        transform: none;\n         transition: all 1s ease-out;\n        .modal-dialog{\n            transform: translate(0,0) !important;\n\n            transition: all 1s ease-out;\n        }\n        &.fade{\n            transition: all 1s ease-out !important;\n        }\n\n    }\n    .modal-dialog {\n       transition: transform 1s ease-out;\n        transform: translate(0,300px) !important;\n        bottom: 0 !important;\n        left: 0% !important;\n        right: 0% !important;\n        position: fixed;\n        min-height: auto;\n        margin-bottom: 0 !important;\n    }\n    .modal-body {\n      svg {\n        width: 4.5rem;\n        height: 4.5rem;\n      }\n      h3 {\n        font-size: 1rem;\n      }\n      p {\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: var(--gray-40);\n        margin-bottom: 0;\n        svg {\n          height: 0.875rem;\n          width: 0.875rem;\n        }\n       span {\n        color:var(--blue-300) ;\n        font-weight: 600;\n       }\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
